import { Component, OnInit } from "@angular/core";
import { AdminService } from "../../../shared/services/admin.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { empty } from "../../../functions";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { TagService } from "../../../api/services/tag.service";
import { Tag } from "../../../api/models/tag";

@Component({
  selector: "app-modal-admin-areaofinterest",
  templateUrl: "./modal-admin-areaofinterest.component.html",
  styleUrls: ["./modal-admin-areaofinterest.component.scss"],
  standalone: false,
})
export class ModalAdminAreaofinterestComponent implements OnInit {
  public data: any;

  entity = {
    id: "",
    name: "",
    nameBe: "",
    nameEn: "",
    nameDe: "",
    nameFr: "",
    namePt: "",
    description: "",
    descriptionBe: "",
    descriptionEn: "",
    descriptionDe: "",
    descriptionFr: "",
    descriptionPt: "",
    tags: <any>[],
  };

  availableTags: Tag[] = [];

  /**
   * Constructor
   *
   * @param activeModal
   * @param adminService
   * @param areaOfInterestService
   */
  constructor(
    public activeModal: NgbActiveModal,
    public adminService: AdminService,
    private tagService: TagService
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.entity = this.data.entity;
    this.entity.tags = this.entity.tags || [];
    this.loadTags();
  }

  loadTags() {
    this.tagService
      .getTags()
      .pipe(catchError(() => of(null)))
      .subscribe((result) => {
        if (result?.data) {
          this.availableTags = result.data;
        }
      });
  }

  /**
   * Save
   *
   * @constructor
   */
  onTagCreated(tagName: string) {
    this.tagService
      .createTag({ body: { name: tagName } })
      .pipe(catchError(() => of(null)))
      .subscribe((newTag) => {
        if (newTag) {
          this.availableTags = [...this.availableTags, newTag];
        }
      });
  }

  Save() {
    // Update
    if (!empty(this.entity.id)) {
      this.adminService
        .apiUpdateAreaofinterest(this.entity)
        .pipe(
          catchError(
            this.adminService.handleError("apiUpdateAreaofinterest", false)
          )
        )
        .subscribe((result) => {
          if (result !== false) {
            this.activeModal.close(true);
          }
        });
    }
    // Create
    else {
      const { id, ...body } = this.entity;
      this.adminService
        .apiAddAreaofinterest(body)
        .pipe(
          catchError(
            this.adminService.handleError("apiAddAreaofinterest", false)
          )
        )
        .subscribe((result) => {
          if (result !== false) {
            this.activeModal.close(true);
          }
        });
    }
  }
}
